/* eslint-disable no-unused-vars */
import { useTranslation } from 'next-i18next'
import React from 'react'
import { CustomRadioGroup, CustomRadio } from 'src/components'

interface AcquisitionCheckboxProps {
  stockRestFlag: 'REST' | 'OUTSIDE_PLATFORM'
  setStockRestFlag: (value: 'REST' | 'OUTSIDE_PLATFORM') => void
}

const AcquisitionCheckbox: React.FC<AcquisitionCheckboxProps> = (props) => {
  const { t } = useTranslation()

  return <div className='centered'>
    {/* Flag Fields */}
    <CustomRadioGroup
      defaultValue={props.stockRestFlag}
      handleChange={(value: 'REST' | 'OUTSIDE_PLATFORM') => props.setStockRestFlag(value)}
    >
      <CustomRadio value='REST' text={t('admin.Brokerage.StockRest')} />
      <CustomRadio value='OUTSIDE_PLATFORM' text={t('admin.Brokerage.OutsidePlatform')} />
    </CustomRadioGroup>
  </div>
}

export default AcquisitionCheckbox
